import React from 'react';
import { Worker, Viewer, TextDirection } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import '@react-pdf-viewer/toolbar/lib/styles/index.css';
import './chromePdfStyle.css'; // ✳️ التنسيقات التي تحاكي Chrome
function AgreementViewer({ pdfUrl, onConfirm }) {


    const defaultLayoutPluginInstance = defaultLayoutPlugin({
        sidebarTabs: () => [],
    });

    return (

        // <div>
        //     {/* زر تحميل مستقل خارج الـ Viewer */}
        //     <DownloadButton />
        <div className="chrome-pdf-container">
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
                <Viewer
                    fileUrl={pdfUrl}
                    plugins={[defaultLayoutPluginInstance]}
                    theme={{
                        direction: TextDirection.RightToLeft,
                    }}
                />
            </Worker>
        </div>
        // </div>
    );
}

export default AgreementViewer;
